// extracted by mini-css-extract-plugin
module.exports = {"drag":"styles_drag__1EMP8","img":"styles_img__3eIt7"};